import { FC, HTMLAttributes, PropsWithChildren } from "react";
import "./FlagDivider.scss";


type FlagDividerProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    type?: "default" | "green";
  }
>;
export const FlagDivider: FC<FlagDividerProps> = ({
  type = "default"
}) => {
  const isDefault = type === "default";
  return (
    <div className={`decorative-divider ${type}`}>
      <span className="line"></span>
      <span className="icon">
        <img
          src={isDefault ? "/images/home/left-black-flag.svg" : "/images/home/left-green-flag.svg"}
          alt="left flag"
          className="flag left-flag"
          loading="lazy" // Added lazy loading
        />
        <img
          src={isDefault ? "/images/home/star-default.svg" : "/images/home/star-green.svg"}
          alt="star icon"
          className="plus"
          loading="lazy" // Added lazy loading
        />
        <img
          src={isDefault ? "/images/home/right-black-flag.svg" : "/images/home/right-green-flag.svg"}
          alt="left flag"
          className="flag right-flag"
          loading="lazy" // Added lazy loading
        />
      </span>
      <span className="line"></span>
    </div>
  );
}